import {FC} from 'react'
import {
  BsCloudUpload,
  BsFileEarmarkPdfFill,
  BsFiletypeCsv,
  BsFiletypeDoc,
  BsFiletypeDocx,
  BsFiletypeJpg,
  BsFiletypePng,
  BsFiletypeSvg,
  BsFiletypeXls,
  BsFiletypeXlsx,
} from 'react-icons/bs'

interface RenderFileIconProps {
  fileType: string | null | undefined
}

const RenderFileIcon: FC<RenderFileIconProps> = ({fileType}) => {
  switch (fileType) {
    case 'image/jpeg':
      return (
        <>
          <BsFiletypeJpg
            className={`fs-3 mb-2
        `}
          />
        </>
      )
    case 'application/pdf':
      return (
        <BsFileEarmarkPdfFill
          className={`fs-3 mb-2
        `}
        />
      )
    case 'application/msword':
      return (
        <BsFiletypeDoc
          className={`fs-3 mb-2
        `}
        />
      )
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return (
        <BsFiletypeDocx
          className={`fs-3 mb-2
        `}
        />
      )
    case 'image/png':
      return (
        <BsFiletypePng
          className={`fs-3 mb-2
        `}
        />
      )
    case 'image/svg':
      return (
        <BsFiletypeSvg
          className={`fs-3 mb-2
        `}
        />
      )
    case 'text/csv':
      return (
        <BsFiletypeCsv
          className={`fs-3 mb-2
          `}
        />
      )
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return (
        <BsFiletypeXlsx
          className={`fs-3 mb-2
            `}
        />
      )
    case 'application/vnd.ms-excel':
      return (
        <BsFiletypeXls
          className={`fs-3 mb-2
            `}
        />
      )
    default:
      return (
        <BsCloudUpload
          className={`fs-3 mb-2
        `}
        />
      )
  }
}

export default RenderFileIcon
